import { useContext } from 'react';

import { GenericContactFormContext } from '@/context/genericContactFormContext';

export function useGenericContactFormContext() {
  return useContext(GenericContactFormContext);
}
